module.exports = __webpack_public_path__ + "media/images/login-efbb3937a6e2694743d1f4baf05030f7.png";